import { NullLogger } from '@fds/wm-typescript-logger';

const DEFAULT_LOGGER = new NullLogger();
const useLogger = (options) => {
  const getLogger = () => {
    var _a;
    return (_a = options == null ? void 0 : options.logger) != null ? _a : DEFAULT_LOGGER;
  };
  return {
    getLogger
  };
};

export { useLogger };
